<template>
  <div>
    <div class="tab-buttons">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{ active: selectedTab === index }"
        @click="selectTab(index)"
      >
        {{ tab.title }}
      </button>
    </div>
    <div class="tab-content">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { provide, ref } from 'vue';

const tabs = ref([]);
const selectedTab = ref(0);

function selectTab(index) {
  selectedTab.value = index;
}

function registerTab(tab) {
const existing = tabs.value.find(t => t.title === tab.title);
  if (existing) {
    return existing.index;
  }

  const index = tabs.value.length;
  tabs.value.push({ ...tab, index });
  return index;
}

provide('registerTab', registerTab);
provide('selectedTab', selectedTab);
</script>

<style scoped>

button {
  background: none;
  border: none;
  font-size: 20px;
  color: white;
  padding: 1rem 0;
  position: relative;
  cursor: pointer;
  font-weight: 500;
}

button.active {
  color: #ffc627;
  font-weight: bold;
}

button.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 10px;
  background: #ffc627;
}
</style>